<template>
    <v-card
        width="100%"
        rounded="lg"
    >
        <div class="d-flex align-center justify-space-between ga-3 pa-5">
            <span class="font-weight-black">{{name}}</span>
            <v-btn
                variant="plain"
                class="text-body-1 w-auto h-auto px-0"
                color="grey-lighten-1"
                @click="emit('close')"
                style="min-width: initial"
            >
                <template #default>
                    <v-icon :icon="mdiClose" size="24"></v-icon>
                </template>
            </v-btn>
        </div>
        <v-divider></v-divider>
        <div class="d-flex flex-column flex-md-row">
            <div class="flex-grow-1 d-flex align-center product-swiper position-relative" style="min-width: 0;">
                <div class="swiper-button-prev" id="gallery-prev">
                    <v-icon :icon="mdiArrowLeft" color="grey-darken-1"></v-icon>
                </div>
                <swiper
                    :modules="[Thumbs, EffectFade, Navigation, Keyboard]"
                    :thumbs="{ swiper: swiperThumbs, multipleActiveThumbs: false, autoScrollOffset: 1 }"
                    :navigation="{
                        nextEl: '#gallery-next',
                        prevEl: '#gallery-prev'
                    }"
                    :keyboard="{
                      enabled: true,
                    }"
                    class="d-flex w-100 main-swiper align-center h-100"
                    slides-per-view="1"
                    effect="fade"
                    :direction="$vuetify.display.mdAndUp?'vertical':'horizontal'"
                    :fade-effect="{crossFade: true}"
                    :initial-slide="index"
                    :zoom="false"
                    @swiper="swiperMain = $event"
                    style="max-height: 75dvh"
                >
                    <swiper-slide v-for="media in images" :key="media.id" class="text-center h-100">
                        <div class="h-100">
                            <v-img
                                :src="media.url" class="main-image mx-auto"
                                :alt="media.alt"
                                max-width="100%"
                                min-height="2"
                                :height="$vuetify.display.mdAndUp ? 'auto' : $vuetify.display.height - 250"
                                contain
                                width="100%"
                                @click.stop
                            />
                        </div>
                    </swiper-slide>
                </swiper>
                <div class="swiper-button-next" id="gallery-next">
                    <v-icon :icon="mdiArrowRight" color="grey-darken-1"></v-icon>
                </div>
            </div>
            <v-divider vertical></v-divider>
            <div class="py-5 px-10">
                <swiper
                    :modules="[Thumbs]"
                    :space-between="10"
                    :initial-slide="index"
                    slides-per-view="auto"
                    watch-slides-progress
                    watch-overflow
                    free-mode
                    :direction="$vuetify.display.mdAndUp?'vertical':'horizontal'"
                    observer
                    observe-slide-children
                    @swiper="swiperThumbs = $event;"
                    style="max-height: 75dvh"
                >
                    <swiper-slide v-for="media in images" :key="media.id" :class="{'h-auto': $vuetify.display.mdAndUp, 'w-auto': $vuetify.display.smAndDown}">
                        <v-img aspect-ratio="1" :width="$vuetify.display.mdAndUp?160:70" cover
                               rounded="normal"
                               :src="media.variants?.[0]?.url || media.url"
                               :alt="media.alt"
                               @click.stop
                               @load="swiperThumbs?.update()"
                        />
                    </swiper-slide>
                </swiper>
            </div>
        </div>
    </v-card>
</template>

<script setup>
import {Swiper, SwiperSlide} from 'swiper/vue';
import {Thumbs, EffectFade, Navigation, Keyboard} from 'swiper/modules';
import 'swiper/css';
import "swiper/css/thumbs";
import "swiper/css/navigation";
import "swiper/css/effect-fade";
import {ref, watch} from "vue";
import {mdiArrowLeft, mdiArrowRight, mdiClose} from "@mdi/js";

const emit = defineEmits(['close'])
const props = defineProps({
    images: Array,
    index: [Number, String],
    name: String
})
const swiperMain = ref(null);
const swiperThumbs = ref(null);
const init = ref(false);
watch(swiperMain, () => {
    init.value = true;
})
</script>

<style scoped lang="scss">


.gallery-root {
    transform: scale(0);
    transition: transform .8s ease-in-out;

    &.init {
        transform: scale(1);
    }
}

</style>
